<script lang="ts" setup>
  import { loadStripe, type StripeEmbeddedCheckout } from '@stripe/stripe-js'
  import type { GiftCardOrderResponse } from '~/types/api/gift-cards'

  const props = defineProps<{
    active: boolean
    paymentResponse: GiftCardOrderResponse | null
  }>()

  onBeforeUnmount(() => {
    if (stripeInstance.value) {
      stripeInstance.value.destroy()
    }
  })

  watch(
    () => props.active,
    (active) => {
      if (active) {
        initialiseStripeCheckout()
      } else if (stripeInstance.value) {
        stripeInstance.value.destroy()
      }
    }
  )

  const $config = useRuntimeConfig()

  const stripeInstance = ref<StripeEmbeddedCheckout | null>(null)
  const stripe = await loadStripe($config.public.stripePublishableKey)

  async function initialiseStripeCheckout() {
    if (!stripe) {
      throw new Error('Failed to load Stripe')
    }

    stripeInstance.value = await stripe.initEmbeddedCheckout({
      clientSecret: props.paymentResponse?.clientSecret as string
    })

    stripeInstance.value.mount('#checkout')
  }
</script>

<template>
  <div id="checkout" />
</template>
